/* BAB Firmenkunden: Blur-Fade-Einblendung (nach Magic UI, MIT). Ohne JS bleibt alles sichtbar. */
(function () {
  var root = document.querySelector('.bfk');
  if (!root || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var items = root.querySelectorAll('[data-bfk-reveal]');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  root.classList.add('is-ready');
  items.forEach(function (el) { io.observe(el); });
})();
